import React from "react"
import backButton from "../assets/back-to-gallery-button.png"

const BackToGalleryButton = () => {
  return (
    <>
      <div className="absolute" style={{ top: "70px" }}>
        <a href="http://picnic-media.com/gallery">
          <img className="pa1 ml4 no-focus" style={{ height: "3rem" }} src={backButton} alt="BackToGalleryButton" />
        </a>
      </div>
    </>
  )
}

export default BackToGalleryButton
